import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../../constants';

const MobileFormToolbar = ({ formId, handleReset }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  return (
    <div className="filter__refine filter__refine--mobile-open">
      <div
        className="reset"
        data-testid="reset-button"
        role="button"
        onClick={handleReset}
        aria-label={t('RESET_ALL_FILTERS')}>
        {t('RESET_ALL_FILTERS')}
      </div>

      <button className="search" type="submit" form={formId}>
        {t('SEARCH_MOBILE_BUTTON_TEXT')}
      </button>
    </div>
  );
};

MobileFormToolbar.propTypes = {
  formId: PropTypes.string.isRequired,
  handleReset: PropTypes.func.isRequired
};

export default MobileFormToolbar;
